import { HtmlHTMLAttributes, useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import { Hint } from '@redoc/ui-kit';
import './Badge.scss';

interface BadgeProps extends HtmlHTMLAttributes<HTMLDivElement> {
	color?: 'red' | 'yellow' | 'blue' | 'green' | string;
	pill?: boolean;
	hint?: string;
	disabled?: boolean;
	align?: 'left' | 'center' | 'right';
	/** Выводить подсказку только при переполнении */
	isOverflowOnlyHinted?: boolean;
}

export const Badge: React.FC<BadgeProps> = (props) => {
	const {
		align = 'left',
		pill = false,
		color = '',
		hint,
		disabled = false,
		isOverflowOnlyHinted = true,
		children,
		className,
		...other
	} = props;

	const spanRef = useRef<HTMLSpanElement>(null);
	const [isOverflow, setIsOverflow] = useState<boolean>(isOverflowOnlyHinted);

	useEffect(() => {
		if (!isOverflowOnlyHinted || !hint) {
			return;
		}
		checkOverflow();
	}, [isOverflowOnlyHinted]);

	/** Проверка на переполнение */
	const checkOverflow = () => {
		if (!spanRef?.current) {
			return true;
		}
		const overflow =
			spanRef.current.scrollWidth <= spanRef.current.clientWidth;
		setIsOverflow(overflow);
		return spanRef.current.scrollWidth <= spanRef.current.clientWidth;
	};

	const classes = classNames(
		'rdc_badge body-small rdc_badge-' + color,
		className,
		{
			'rdc_rounded-pill': pill,
			rdc_disabled: disabled,
		},
	);
	const wrapperProps: any = {
		className: classes,
		...other,
		style: {
			...other.style,
			textAlign: align,
		},
	};

	return (
		<Hint messageText={hint} placement="top" disabled={isOverflow}>
			<div {...wrapperProps} ref={spanRef}>
				<span>{children}</span>
			</div>
		</Hint>
	);
};
